module.exports = __webpack_public_path__ + "static/usha-Normal-c333efd35ed58568c5d2f64801e465a8.jpg";